import {useFormik} from 'formik';
import * as Yup from 'yup';
import {AxiosError} from 'axios';
import {useFundraiser, FundraiserFinanceModel, UpdateFundraiserFinanceDTO} from '../../../entities';
import {dateTimeParse} from '@gravity-ui/date-utils';

type UseEditFundraiserFinanceFormProps = {
  setOpen: (open: boolean) => void;
  fundraiserId: string;
  financeData?: FundraiserFinanceModel;
};

export const useEditFundraiserFinanceForm = ({
  setOpen,
  fundraiserId,
  financeData,
}: UseEditFundraiserFinanceFormProps) => {
  const {updateFundraiserFinanceMutation} = useFundraiser({id: fundraiserId});

  const onSubmit = async (values: any) => {
    try {
      const updateData: UpdateFundraiserFinanceDTO = {
        requiredAmount: values.requiredAmount ? Number(values.requiredAmount) : null,
        commissionPercentage: Number(values.commissionPercentage),
        end: values.end ? values.end.toISOString() : null,
      };

      await updateFundraiserFinanceMutation.mutateAsync(updateData);
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      requiredAmount: financeData?.requiredAmount?.toString() || '',
      commissionPercentage: financeData?.commissionPercentage?.toString() || '1',
      end: financeData?.end ? dateTimeParse(financeData.end) : null,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      requiredAmount: Yup.number()
        .typeError('Должно быть числовым значением')
        .min(1, 'Сумма должна быть больше 0')
        .nullable(),
      commissionPercentage: Yup.number()
        .typeError('Должно быть числовым значением')
        .min(0, 'Процент должен быть положительным числом')
        .required('Комиссия проекта обязательна'),
      end: Yup.mixed().nullable(),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: updateFundraiserFinanceMutation.isPending,
    submitError: updateFundraiserFinanceMutation.error
      ? (updateFundraiserFinanceMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    submitForm: () => formik.handleSubmit(),
  };
};
